import { Link } from 'react-router-dom';
import {
  UserIcon,
  UsersIcon,
  BriefcaseIcon,
} from '@heroicons/react/24/outline';

const audiences = [
  {
    icon: UserIcon,
    title: 'Older Adults',
    stat: '95%',
    statLabel: 'want to stay in their own home',
    description: 'SeniorThrive gives you the tools to do it safely and confidently, on your terms.',
    link: '/older-adults',
    linkLabel: 'Explore Essential',
  },
  {
    icon: UsersIcon,
    title: 'Families',
    stat: '53M',
    statLabel: 'family caregivers across the US',
    description: 'You don\'t have to carry the weight alone. SeniorThrive keeps everyone informed and aligned.',
    link: '/thrivefamily',
    linkLabel: 'Explore Family',
  },
  {
    icon: BriefcaseIcon,
    title: 'Caregivers & Professionals',
    stat: '4.5M',
    statLabel: 'home care workers supporting independence',
    description: 'One shared system for documentation, communication, and care continuity.',
    link: '/caregiver-coordination',
    linkLabel: 'Explore Care Team',
  },
];

const BuiltForMajoritySection = () => {
  return (
    <div className="py-20 lg:py-28 bg-muted/30">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center mb-6">
          <h2 className="text-3xl lg:text-4xl font-bold text-foreground mb-4">
            Built for People Who Choose to{' '}
            <span className="text-primary">Stay Home</span>
          </h2>
          <p className="text-lg text-muted-foreground leading-relaxed">
            The desire to age at home is nearly universal. SeniorThrive makes it a
            realistic, supported choice, not a gamble.
          </p>
        </div>

        <div className="grid sm:grid-cols-3 gap-6 max-w-4xl mx-auto mt-12">
          {audiences.map((a) => (
            <div
              key={a.title}
              className="group text-center p-8 rounded-md bg-background shadow-raised hover:shadow-overlay transition-all duration-300 hover:-translate-y-1"
            >
              <div className="flex items-center justify-center gap-3 mb-5">
                <a.icon className="w-8 h-8 text-primary" />
                <h3 className="font-bold text-foreground text-lg">{a.title}</h3>
              </div>
              <p className="text-3xl font-bold text-primary mb-1">{a.stat}</p>
              <p className="text-muted-foreground mb-4">{a.statLabel}</p>
              <p className="text-muted-foreground leading-relaxed mb-4">{a.description}</p>
              <Link to={a.link} className="text-primary font-bold hover:underline">
                {a.linkLabel} →
              </Link>
            </div>
          ))}
        </div>

        <p className="text-center text-primary font-bold text-lg mt-12">
          Different roles. One connected system. One goal: thriving at home.
        </p>
      </div>
    </div>
  );
};

export default BuiltForMajoritySection;
